import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingBag } from '@fortawesome/pro-regular-svg-icons/faShoppingBag';
import { faStar as farStar } from '@fortawesome/pro-regular-svg-icons/faStar';
import { faInfoCircle } from '@fortawesome/pro-regular-svg-icons/faInfoCircle';
import { faClosedCaptioning } from '@fortawesome/pro-regular-svg-icons/faClosedCaptioning';
import { faCircle } from '@fortawesome/pro-regular-svg-icons/faCircle';

import { faArrowsRotate as faDuoArrowsRotate } from '@fortawesome/pro-duotone-svg-icons/faArrowsRotate';
import { faFileImage } from '@fortawesome/pro-duotone-svg-icons/faFileImage';
import { faGlobePointer } from '@fortawesome/pro-duotone-svg-icons/faGlobePointer';
import { faEnvelopeOpenText } from '@fortawesome/pro-duotone-svg-icons/faEnvelopeOpenText';
import { faThumbsUp } from '@fortawesome/pro-duotone-svg-icons/faThumbsUp';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';

import { faFileVideo } from '@fortawesome/pro-solid-svg-icons/faFileVideo';
import { faCartPlus } from '@fortawesome/pro-solid-svg-icons/faCartPlus';
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faPause } from '@fortawesome/pro-solid-svg-icons/faPause';
import { faStar as fasStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faRectangleList } from '@fortawesome/pro-solid-svg-icons/faRectangleList';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faCirclePlus } from '@fortawesome/pro-solid-svg-icons/faCirclePlus';
import { faBook } from '@fortawesome/pro-solid-svg-icons/faBook';
import { faBan } from '@fortawesome/pro-solid-svg-icons/faBan';

import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faGaugeHigh } from '@fortawesome/pro-solid-svg-icons/faGaugeHigh';
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown';
import { faCode } from '@fortawesome/pro-solid-svg-icons/faCode';
import { faDollar } from '@fortawesome/pro-solid-svg-icons/faDollar';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faBallotCheck } from '@fortawesome/pro-solid-svg-icons/faBallotCheck';
import { faClipboardQuestion } from '@fortawesome/pro-solid-svg-icons/faClipboardQuestion';
import { faLightbulbOn } from '@fortawesome/pro-solid-svg-icons/faLightbulbOn';
import { faMessageQuestion } from '@fortawesome/pro-solid-svg-icons/faMessageQuestion';
import { faHandshakeAngle } from '@fortawesome/pro-solid-svg-icons/faHandshakeAngle';
import { faGraduationCap } from '@fortawesome/pro-solid-svg-icons/faGraduationCap';
import { faBells } from '@fortawesome/pro-solid-svg-icons/faBells';
import { faCircleDollar } from '@fortawesome/pro-solid-svg-icons/faCircleDollar';
import { faVideo } from '@fortawesome/pro-solid-svg-icons/faVideo';
import { faVideoPlus } from '@fortawesome/pro-solid-svg-icons/faVideoPlus';
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faGripDotsVertical } from '@fortawesome/pro-solid-svg-icons/faGripDotsVertical';
import { faClosedCaptioning as faSolidClosedCaptioning } from '@fortawesome/pro-solid-svg-icons/faClosedCaptioning';
import { faCreditCard } from '@fortawesome/pro-solid-svg-icons/faCreditCard';
import { faReceipt } from '@fortawesome/pro-solid-svg-icons/faReceipt';
import { faGridHorizontal } from '@fortawesome/pro-solid-svg-icons/faGridHorizontal';
import { faMagnifyingGlassPlus } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassPlus';
import { faMagnifyingGlassMinus } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassMinus';
import { faVolumeHigh } from '@fortawesome/pro-solid-svg-icons/faVolumeHigh';
import { faVolumeMedium } from '@fortawesome/pro-solid-svg-icons/faVolumeMedium';
import { faVolumeLow } from '@fortawesome/pro-solid-svg-icons/faVolumeLow';
import { faVolumeXmark } from '@fortawesome/pro-solid-svg-icons/faVolumeXmark';
import { faArrowUpRightAndArrowDownLeftFromCenter } from '@fortawesome/pro-solid-svg-icons/faArrowUpRightAndArrowDownLeftFromCenter';
import { faArrowDownLeftAndArrowUpRightToCenter } from '@fortawesome/pro-solid-svg-icons/faArrowDownLeftAndArrowUpRightToCenter';
import { faArrowRightToLine } from '@fortawesome/pro-solid-svg-icons/faArrowRightToLine';
import { faFlagCheckered } from '@fortawesome/pro-solid-svg-icons/faFlagCheckered';
import { faAnchor } from '@fortawesome/pro-solid-svg-icons/faAnchor';
import { faMessageSmile } from '@fortawesome/pro-solid-svg-icons/faMessageSmile';
import { faTrophyStar } from '@fortawesome/pro-solid-svg-icons/faTrophyStar';
import { faCommentDots } from '@fortawesome/pro-solid-svg-icons/faCommentDots';
import { faComments } from '@fortawesome/pro-solid-svg-icons/faComments';
import { faImage } from '@fortawesome/pro-solid-svg-icons/faImage';
import { faImage as faRegularImage } from '@fortawesome/pro-regular-svg-icons/faImage';
import { faWindowRestore } from '@fortawesome/pro-solid-svg-icons/faWindowRestore';
import { faHandWave } from '@fortawesome/pro-solid-svg-icons/faHandWave';
import { faSignalStream } from '@fortawesome/pro-solid-svg-icons/faSignalStream';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faChartMixed } from '@fortawesome/pro-solid-svg-icons/faChartMixed';
import { faAddressCard } from '@fortawesome/pro-solid-svg-icons/faAddressCard';
import { faPuzzlePiece } from '@fortawesome/pro-solid-svg-icons/faPuzzlePiece';
import { faPenToSquare } from '@fortawesome/pro-solid-svg-icons/faPenToSquare';
import { faPenToSquare as faPenToSquareRegular } from '@fortawesome/pro-regular-svg-icons/faPenToSquare';
import { faClone } from '@fortawesome/pro-solid-svg-icons/faClone';
import { faTrashCan } from '@fortawesome/pro-solid-svg-icons/faTrashCan';
import { faCalendarDays } from '@fortawesome/pro-solid-svg-icons/faCalendarDays';
import { faClapperboardPlay } from '@fortawesome/pro-solid-svg-icons/faClapperboardPlay';
import { faCalendarXmark } from '@fortawesome/pro-solid-svg-icons/faCalendarXmark';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { faSliders } from '@fortawesome/pro-solid-svg-icons/faSliders';
import { faCalendarCheck } from '@fortawesome/pro-solid-svg-icons/faCalendarCheck';
import { faAlarmClock } from '@fortawesome/pro-solid-svg-icons/faAlarmClock';
import { faMailbox } from '@fortawesome/pro-solid-svg-icons/faMailbox';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faCommentSms } from '@fortawesome/pro-solid-svg-icons/faCommentSms';
import { faUsersRectangle } from '@fortawesome/pro-solid-svg-icons/faUsersRectangle';
import { faRobot } from '@fortawesome/pro-solid-svg-icons/faRobot';
import { faFilePen } from '@fortawesome/pro-solid-svg-icons/faFilePen';
import { faPalette } from '@fortawesome/pro-solid-svg-icons/faPalette';
import { faPalette as faRegularPalette } from '@fortawesome/pro-regular-svg-icons/faPalette';
import { faLockKeyhole } from '@fortawesome/pro-solid-svg-icons/faLockKeyhole';
import { faPenField } from '@fortawesome/pro-solid-svg-icons/faPenField';
import { faFileCircleCheck } from '@fortawesome/pro-solid-svg-icons/faFileCircleCheck';
import { faFont } from '@fortawesome/pro-solid-svg-icons/faFont';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faSquareCaretDown } from '@fortawesome/pro-solid-svg-icons/faSquareCaretDown';
import { faCaretUp } from '@fortawesome/pro-solid-svg-icons/faCaretUp';
import { faTextSize } from '@fortawesome/pro-solid-svg-icons/faTextSize';
import { faLanguage } from '@fortawesome/pro-solid-svg-icons/faLanguage';
import { faChalkboardUser } from '@fortawesome/pro-solid-svg-icons/faChalkboardUser';
import { faPersonWalkingArrowRight } from '@fortawesome/pro-solid-svg-icons/faPersonWalkingArrowRight';
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { faBoxArchive } from '@fortawesome/pro-solid-svg-icons/faBoxArchive';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faCircleUser } from '@fortawesome/pro-solid-svg-icons/faCircleUser';
import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons/faArrowsRotate';
import { faSackDollar } from '@fortawesome/pro-solid-svg-icons/faSackDollar';
import { faUserPlus } from '@fortawesome/pro-solid-svg-icons/faUserPlus';
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import { faGears } from '@fortawesome/pro-solid-svg-icons/faGears';
import { faTools } from '@fortawesome/pro-solid-svg-icons/faTools';
import { faArrowRotateRight } from '@fortawesome/pro-solid-svg-icons/faArrowRotateRight';
import { faUsersLine } from '@fortawesome/pro-solid-svg-icons/faUsersLine';
import { faCircleP } from '@fortawesome/pro-solid-svg-icons/faCircleP';
import { faUserGroup } from '@fortawesome/pro-solid-svg-icons/faUserGroup';
import { faStopwatch } from '@fortawesome/pro-solid-svg-icons/faStopwatch';
import { faHourglassHalf } from '@fortawesome/pro-solid-svg-icons/faHourglassHalf';
import { faBars } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faGrid2 } from '@fortawesome/pro-solid-svg-icons/faGrid2';
import { faMessageQuote } from '@fortawesome/pro-solid-svg-icons/faMessageQuote';
import { faArrowUpFromBracket } from '@fortawesome/pro-solid-svg-icons/faArrowUpFromBracket';
import { faStamp } from '@fortawesome/pro-solid-svg-icons/faStamp';
import { faDesktop } from '@fortawesome/pro-solid-svg-icons/faDesktop';
import { faMobile } from '@fortawesome/pro-solid-svg-icons/faMobile';
import { faAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faUsers } from '@fortawesome/pro-regular-svg-icons/faUsers';
import { faHandWave as faHandWaveRegular } from '@fortawesome/pro-regular-svg-icons/faHandWave';
import { faRocketLaunch } from '@fortawesome/pro-regular-svg-icons/faRocketLaunch';
import { faGraduationCap as faGraduationCapRegular } from '@fortawesome/pro-regular-svg-icons/faGraduationCap';
import { faThumbsUp as faThumbsUpRegular } from '@fortawesome/pro-regular-svg-icons/faThumbsUp';
import { faHouseLaptop } from '@fortawesome/pro-regular-svg-icons/faHouseLaptop';
import { faHouse } from '@fortawesome/pro-regular-svg-icons/faHouse';
import { faBooks as faBooksRegular } from '@fortawesome/pro-regular-svg-icons/faBooks';
import { faNewspaper } from '@fortawesome/pro-regular-svg-icons/faNewspaper';
import { faSquareQuestion } from '@fortawesome/pro-regular-svg-icons/faSquareQuestion';
import { faDatabase } from '@fortawesome/pro-regular-svg-icons/faDatabase';
import { faUsers as faSolidUsers } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faRabbit } from '@fortawesome/pro-regular-svg-icons/faRabbit';
import { faStop as faSolidStop } from '@fortawesome/pro-solid-svg-icons/faStop';

import { faKey as faRegularKey } from '@fortawesome/pro-solid-svg-icons/faKey';
import { faPersonChalkboard } from '@fortawesome/pro-solid-svg-icons/faPersonChalkboard';
import { faMicrophoneStand } from '@fortawesome/pro-solid-svg-icons/faMicrophoneStand';
import { faBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faCrown } from '@fortawesome/pro-solid-svg-icons/faCrown';
import { faCircleEllipsis } from '@fortawesome/pro-solid-svg-icons/faCircleEllipsis';
import { faScreenUsers } from '@fortawesome/pro-solid-svg-icons/faScreenUsers';
import { faPuzzle } from '@fortawesome/pro-solid-svg-icons/faPuzzle';
import { faCookieBite } from '@fortawesome/pro-solid-svg-icons/faCookieBite';
import { faTv } from '@fortawesome/pro-solid-svg-icons/faTv';
import { faScissors } from '@fortawesome/pro-solid-svg-icons/faScissors';
import { faDatabase as faSolidDatabase } from '@fortawesome/pro-solid-svg-icons/faDatabase';
import { faInfoCircle as faSolidInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faLightbulbGear } from '@fortawesome/pro-solid-svg-icons/faLightbulbGear';
import { faDesktop as faLightDesktop } from '@fortawesome/pro-light-svg-icons/faDesktop';
import { faClone as faRegularClone } from '@fortawesome/pro-light-svg-icons/faClone';
import { faTableLayout } from '@fortawesome/pro-light-svg-icons/faTableLayout';
import { faClipboardCheck } from '@fortawesome/pro-light-svg-icons/faClipboardCheck';

import { faCalendarCirclePlus } from '@fortawesome/pro-regular-svg-icons/faCalendarCirclePlus';
import { faHands } from '@fortawesome/pro-regular-svg-icons/faHands';
import { faDesktop as faRegularDesktop } from '@fortawesome/pro-regular-svg-icons/faDesktop';
import { faEarthAmericas as faRegularEarthAmericas } from '@fortawesome/pro-regular-svg-icons/faEarthAmericas';
import { faMessageSmile as faRegularMessageSmile } from '@fortawesome/pro-regular-svg-icons/faMessageSmile';
import { faCircleInfo as faRegularCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';
import { faCartShopping } from '@fortawesome/pro-regular-svg-icons/faCartShopping';
import { faUserPlus as faRegularUserPlus } from '@fortawesome/pro-regular-svg-icons/faUserPlus';
import { faArrowsRotate as faRegularArrowsRotate } from '@fortawesome/pro-regular-svg-icons/faArrowsRotate';
import { faCalendarStar } from '@fortawesome/pro-regular-svg-icons/faCalendarStar';
import { faCalendarDays as faRegularCalendarDays } from '@fortawesome/pro-regular-svg-icons/faCalendarDays';
import { faClapperboardPlay as faRegularClapperboardPlay } from '@fortawesome/pro-regular-svg-icons/faClapperboardPlay';
import { faCloudArrowUp } from '@fortawesome/pro-regular-svg-icons/faCloudArrowUp';
import { faCloudArrowDown } from '@fortawesome/pro-regular-svg-icons/faCloudArrowDown';
import { faLink as faRegularLink } from '@fortawesome/pro-regular-svg-icons/faLink';
import { faHand } from '@fortawesome/pro-regular-svg-icons/faHand';
import { faList } from '@fortawesome/pro-regular-svg-icons/faList';
import { faArrowUpRight } from '@fortawesome/pro-solid-svg-icons/faArrowUpRight';
import { faMinus } from '@fortawesome/pro-regular-svg-icons/faMinus';
import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faArrowLeft } from '@fortawesome/pro-light-svg-icons/faArrowLeft';
import { faCartMinus as faRegularCartMinus } from '@fortawesome/pro-regular-svg-icons/faCartMinus';
import { faCartXmark as faRegularCartXmark } from '@fortawesome/pro-regular-svg-icons/faCartXmark';
import { faMailboxFlagUp } from '@fortawesome/pro-regular-svg-icons/faMailboxFlagUp';
import { faMailbox as faRegularMailbox } from '@fortawesome/pro-regular-svg-icons/faMailbox';
import { faMemoCircleInfo } from '@fortawesome/pro-regular-svg-icons/faMemoCircleInfo';
import { faSquareUser } from '@fortawesome/pro-regular-svg-icons/faSquareUser';
import { faFilterList } from '@fortawesome/pro-solid-svg-icons/faFilterList';
import { faPencil } from '@fortawesome/pro-solid-svg-icons/faPencil';
import { faCircleVideo } from '@fortawesome/pro-solid-svg-icons/faCircleVideo';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { faAtomSimple } from '@fortawesome/pro-solid-svg-icons/faAtomSimple';
import { faAtomSimple as faRegularAtomSimple } from '@fortawesome/pro-regular-svg-icons/faAtomSimple';
import { faCommentCheck } from '@fortawesome/pro-regular-svg-icons/faCommentCheck';
import { faRectangleList as faRegularRectangleList } from '@fortawesome/pro-regular-svg-icons/faRectangleList';
import { faCirclePlus as faRegularCirclePlus } from '@fortawesome/pro-regular-svg-icons/faCirclePlus';
import { faReply } from '@fortawesome/pro-regular-svg-icons/faReply';
import { faHandPointUp } from '@fortawesome/pro-regular-svg-icons/faHandPointUp';
import { faHandPointer } from '@fortawesome/pro-solid-svg-icons/faHandPointer';
import { faSparkles } from '@fortawesome/pro-solid-svg-icons/faSparkles';
import { faTag as faTagRegular } from '@fortawesome/pro-regular-svg-icons/faTag';
import { faSignPost } from '@fortawesome/pro-solid-svg-icons/faSignPost';
import { faSignPost as faRegularSignPost } from '@fortawesome/pro-regular-svg-icons/faSignPost';
import { faSquareEnvelope } from '@fortawesome/pro-light-svg-icons/faSquareEnvelope';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type FCC = React.FC<any>;

export const NewSpinner: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCircleNotch} spin={true} />
);
export const GripIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faGripDotsVertical} />;
export const StopIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faSolidStop} />;

// Favs
export const StarIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={farStar} />;
export const StarFilledIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={fasStar} />;
export const BookIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faBook} />;

// Interactions Tab

export const InteractionsIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faWindowRestore} />
);

// Interactions
export const TestimonialIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faMessageQuote} />;
export const ImageOverlayIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faImage} />;
export const ImageIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faRegularImage} />;
export const AnchorIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faAnchor} />;
export const FlagIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faFlagCheckered} />;
export const PollIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faBallotCheck} />;
export const QuizIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faClipboardQuestion} />;
export const HandoutIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faLink} />;
export const OfferIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faTrophyStar} />;
export const TipIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faLightbulbOn} />;
export const FeedbackIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faMessageSmile} />;
export const QuestionIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faMessageQuestion} />;
export const KofiIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCircleDollar} />;
export const ConversionNotificationsIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faBells} />
);
export const ContactRequestIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faHandshakeAngle} />
);
export const ThinkificCardIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faGraduationCap} />
);
export const PrivateMessageIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCommentDots} />
);

// Interaction controls

export const OpenPaneIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faArrowRightToLine} />
);
export const JumpIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faArrowRightToLine} />;
export const BackIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faChevronLeft} />;

// Interaction view

export const Grid2Icon: FCC = (props) => <FontAwesomeIcon {...props} icon={faGrid2} />;
export const BarsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faBars} />;

// General settings

export const ReplaceVideoIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faVideoPlus} />;
export const InfoIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCircleInfo} />;
export const LiteInfoIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faInfoCircle} />;
export const AddIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCirclePlus} />;
export const SearchIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faMagnifyingGlass} />;

// My plan pages

export const KeyIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faKey} />;
export const LockKeyhole: FCC = (props) => <FontAwesomeIcon {...props} icon={faLockKeyhole} />;
export const GlobeIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faGlobe} />;

// Chat Tab
export const ChatIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faComments} />;
export const WelcomeMessagesIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faHandWave} />;

// Chat

export const ChatLiveIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faSignalStream} />;
export const SendIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faArrowUp} />;

// Video controls

export const PlayIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faPlay} />;
export const PauseIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faPause} />;

export const AgendaIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faRectangleList} />;
export const CloseTrayIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faAngleDown} />;
export const VolumeHighIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faVolumeHigh} />;
export const VolumeMidIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faVolumeMedium} />;
export const VolumeLowIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faVolumeLow} />;
export const VolumeMuteIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faVolumeXmark} />;
export const DisabledCCIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faClosedCaptioning} />
);
export const EnabledCCIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faSolidClosedCaptioning} />
);
export const ScreenGrowIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faArrowUpRightAndArrowDownLeftFromCenter} />
);
export const ScreenShrinkIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faArrowDownLeftAndArrowUpRightToCenter} />
);

// Misc
export const TestControlsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faGaugeHigh} />;
export const ProductHuntPromoIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCircleP} />;

// User Profile View
export const ProfileIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCircleUser} transform='grow-4' />
);
export const PlanIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faArrowsRotate} transform='grow-2' />
);
export const RewardsIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faSackDollar} transform='grow-2' />
);
export const TeamIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faUserPlus} />;
export const IntegrationsIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faGears} transform='grow-2' />
);
export const DomainIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faGlobe} />;

// My Plan Tab
export const SummaryIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faGridHorizontal} />;
export const SubscriptionsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faDollar} />;
export const AddonsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCartPlus} />;
export const CreditCardIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCreditCard} />;
export const BillingContactsIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faUsersLine} transform={'grow-2'} />
);
export const InvoicesIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faReceipt} />;
export const PurchaseIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faShoppingBag} />;
export const CloseDownIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faChevronDown} />;

// Homepage & Dashboard
export const HomeIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faHouse} />;
export const ShareIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faPaperPlane} />;
export const AnalyticsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faChartMixed} />;
export const RegistrantsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faAddressCard} />;
export const WidgetIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faPuzzlePiece} />;
export const EditIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faPenToSquare} />;
export const DuplicateIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faClone} />;
export const BanIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faBan} />;
export const AllowIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCircle} />;
export const DeleteIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faTrashCan} />;
export const ToolsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faTools} />;
export const CartMinusIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularCartMinus} />
);
export const CartXmarkIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularCartXmark} />
);
export const MailboxRegularIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularMailbox} />
);
export const MailboxFlagUpIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faMailboxFlagUp} />
);
export const MemoCircleInfoIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faMemoCircleInfo} />
);
export const SquareUserIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faSquareUser} />;
export const UserIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faUser} />;

// Edit View
// Schedule Tab
export const CalendarDaysIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCalendarDays} />
);
export const CalendarXMarkIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCalendarXmark} />
); // Used as Session Availability navbar icons
export const HourglassHalfIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faHourglassHalf} />
); // Used as JIT navbar icon
export const ClapperboardPlayIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faClapperboardPlay} />
); // Used as Replay navbar icon
export const GearIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faGear} />; // Used as config Timezone icon

// Notifications Tab
export const NotificationsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faBell} />;
export const SettingsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faSliders} />;
export const CalendarCheckIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCalendarCheck} />
); // Used as Confirmations navbar icon
export const AlarmClockIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faAlarmClock} />;
export const MailboxIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faMailbox} />;
export const EnvelopeIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faEnvelope} />;
export const SMSIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCommentSms} />;

// Chat Tab
export const ModeratorsIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faUsersRectangle} />
);
export const RobotIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faRobot} />;

// Registration Tab
export const RegistrationPageIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faFilePen} />;
export const ThemeIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faPalette} />;
export const PaletteIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faRegularPalette} />;
export const DatabaseIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faDatabase} />;
export const AccessControlIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faLockKeyhole} />
);
export const CodeIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCode} />;
export const RegistrationFormIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faPenField} />
);
export const InVideoRegistrationIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faFilePen} />
);
export const ThankYouPageIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faFileCircleCheck} />
);
export const FingerUpIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faHandPointUp} />;
export const HandPointerIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faHandPointer} />;
export const FontSizeIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faTextSize} />;
export const FontIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faFont} />;
export const DownArrowIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCaretDown} transform='grow-12' />
);
export const UpArrowIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCaretUp} transform='grow-12' />
);
export const SquareDownArrowIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faSquareCaretDown} />
);
export const FilterListIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faFilterList} transform={{ flipX: true }} />
);
export const PencilIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faPencil} transform={{ flipX: true }} />
);
export const CircleVideoIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCircleVideo} />;

// Settings Tab
export const LangIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faLanguage} fixedWidth transform='grow-2' />
);
export const BasicIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faSolidInfoCircle} />;
export const Credits: FCC = (props) => <FontAwesomeIcon {...props} icon={faStamp} />;
export const PresentationIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faChalkboardUser} />
);
export const ExitIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faPersonWalkingArrowRight} />
);
export const TagIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faTag} />;

// Analytics View
export const DownloadIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCloudArrowDown} />;
// Chat tab inside Analytics
export const ArchiveIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faBoxArchive} />;
export const AttendeesIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faUserGroup} />;
export const WatchedPercentIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faStopwatch} />;

// Integrations Card
export const ReplayIntegrationsIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faArrowRotateRight} />
);
export const RefreshIntegrationsIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faArrowsRotate} />
);

export const RefreshIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faDuoArrowsRotate} />;

// Add Video workflow
export const UploadIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faArrowUpFromBracket} />
);
export const VideoIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faVideo} />;

export const InternetURLIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faGlobePointer} />;
export const ImageUploadIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faFileImage} />;
export const VideoFileIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faFileVideo} />;
export const DesktopIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faDesktop} />;
export const MobileIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faMobile} />;

export const ArrowRightIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faAngleRight} />;

export const ZoomPlus: FCC = (props) => <FontAwesomeIcon {...props} icon={faMagnifyingGlassPlus} />;
export const ZoomMinus: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faMagnifyingGlassMinus} />
);

export const NextIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faAngleRight} />;
export const PrevIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faAngleLeft} />;

export const MailEnvelopeIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faEnvelopeOpenText} />
);
export const SuccessIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faThumbsUp} />;

// Header navigation
export const UsersIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faUsers} />;
export const HandWaveRegularIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faHandWaveRegular} />
);
export const GraduationCapRegularIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faGraduationCapRegular} />
);
export const RocketLaunchIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRocketLaunch} />
);
export const ThumbsUpRegularIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faThumbsUpRegular} />
);
export const HouseLaptopIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faHouseLaptop} />;
export const HouseIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faHouse} />;
export const BooksIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faBooksRegular} />;
export const NewspaperIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faNewspaper} />;
export const SquareQuestionIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faSquareQuestion} />
);

export const RegularKeyIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faRegularKey} />;
export const PersonChalkboardIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faPersonChalkboard} />
);
export const MicrophoneStandIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faMicrophoneStand} />
);
export const BuildingIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faBuilding} />;
export const CrownIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCrown} />;
export const CircleEllipsisIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCircleEllipsis} />
);
export const ScreenUsersIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faScreenUsers} />;
export const PuzzleIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faPuzzle} />;
export const CookieBiteIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCookieBite} />;
export const TvIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faTv} />;
export const ScissorsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faScissors} />;
export const DatabaseSolidIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faSolidDatabase} />
);
export const InfoCircleSolidIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faSolidInfoCircle} />
);
export const UsersSolidIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faSolidUsers} />;
export const LightbulbGearIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faLightbulbGear} />
);
export const LightDesktopIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faLightDesktop} />
);
export const RegularCloneIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularClone} />
);
export const TableLayoutIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faTableLayout} />;
export const RabbitIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faRabbit} />;
export const ClipboardCheckIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faClipboardCheck} />
);
export const CalendarCirclePlusIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCalendarCirclePlus} />
);
export const HandsIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faHands} />;
export const RegularDesktopIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularDesktop} />
);
export const RegularEarthAmericas: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularEarthAmericas} />
);
export const MessageSmileIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularMessageSmile} />
);
export const RegularCircleInfoIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularCircleInfo} />
);
export const CartShoppingIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCartShopping} />
);
export const RegularUserPlusIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularUserPlus} />
);
export const RegularArrowsRotateIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularArrowsRotate} />
);
export const CalendarStarIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCalendarStar} />
);
export const RegularCalendarDaysIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularCalendarDays} />
);
export const RegularClapperboardPlayIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularClapperboardPlay} />
);
export const CloudArrowUpIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCloudArrowUp} />
);
export const CloudArrowDownIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCloudArrowDown} />
);
export const RegularLinkIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faRegularLink} />;
export const HandIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faHand} />;
export const ListIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faList} />;
export const ArrowUpRightIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faArrowUpRight} />
);
export const MinusIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faMinus} />;
export const PlusIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faPlus} />;
export const ArrowLeftIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faArrowLeft} />;
export const CloseIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faXmark} />;
export const ClearIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faXmark} />;
export const CheckIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faCheck} />;

export const AIIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faSparkles} />;
export const AtomSimpleIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faAtomSimple} />;
export const PenToSquareIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faPenToSquareRegular} />
);
export const CommentCheckIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faCommentCheck} />
);
export const RegularRectangleListIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularRectangleList} />
);
export const RegularCirclePlusIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularCirclePlus} />
);
export const ReplyIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faReply} />;
export const RegularTagIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faTagRegular} />;
export const SignPostIcon: FCC = (props) => <FontAwesomeIcon {...props} icon={faSignPost} />;
export const SignPostRegularIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularSignPost} />
);
export const AtomSimpleRegularIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faRegularAtomSimple} />
);
export const SquareEnvelopeIcon: FCC = (props) => (
  <FontAwesomeIcon {...props} icon={faSquareEnvelope} />
);
